import React from "react";
import styled from "styled-components";
import BadgeButton from "../../ui-library/Buttons/BadgeButton/BadgeButton";
import { Row, Col } from "react-bootstrap";

const PageButtonsWrapper = styled(Row)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  gap: 16px;
  padding: 0;
  margin: 0;

  @media screen and (orientation: portrait) {
    flex-direction: column;
    gap: 8px;
  }
`;

const PageButtonsCol = styled.div`
  padding: 0;

  &:only-child {
    flex: 1;
  }

  @media screen and (orientation: landscape) {
    flex: 0 0 calc(50% - 8px);
  }
`;

const TopPageButtons = ({ buttons }) => {
  return (
    <PageButtonsWrapper data-testid="top-page-buttons">
      {buttons.map((item) => (
        <PageButtonsCol key={item.id}>
          <BadgeButton
            data-testid={item.dataTestId}
            text={item.text}
            onClick={item.onClick}
          />
        </PageButtonsCol>
      ))}
    </PageButtonsWrapper>
  );
};

export default TopPageButtons;
